/**
 * pj-localization-disclosure.js — Selector país+idioma COMBINADO de PanamaJack
 * ---------------------------------------------------------------------------
 * QUÉ HACE / POR QUÉ
 * PJ fusiona país e idioma en un único disclosure (snippet `localization.liquid`):
 * el mismo formulario `localization` contiene a la vez el input oculto
 * `country_code` y `locale_code`, y sus opciones llevan `data-tipo='country'`
 * o `data-tipo='lengua'`. El formulario de Shopify solo debe enviar UNO de los
 * dos códigos: si se envían ambos, el cambio se interpreta mal. En 6.0.0 esto se
 * resolvía con un parche dentro de `theme.Disclosure._submitForm`, que ANTES del
 * submit ELIMINABA el input que NO corresponde al `data-tipo` clicado
 * (tipo=='lengua' → quita `country_code`; en otro caso → quita `locale_code`).
 *
 * Tras rebasar el `theme.js` al VENDOR 10.2.0, ese `theme.Disclosure` ya NO trae
 * el parche: el disclosure nativo escribe el valor en el input correspondiente y
 * envía el formulario, pero deja vivos AMBOS inputs. Este módulo reintroduce
 * SOLO la poda, de forma iso-funcional con 6.0.0.
 *
 * CÓMO (sin romper el disclosure nativo, sin duplicar el submit)
 * Escucha el `click` en las opciones (`a[data-tipo][data-disclosure-option]`)
 * mediante DELEGACIÓN en `document` y en FASE DE CAPTURA. Al ejecutarse antes que
 * el handler de submit del vendor (que va en fase de burbuja), la poda ya está
 * hecha cuando el vendor envía el formulario. No re-implementa toggle, ni el set
 * del valor, ni el submit: solo elimina el input sobrante del form `localization`.
 *
 * - Idempotente: si el input ya no existe, no hace nada.
 * - Null-guards: si no hay opción, ni `data-tipo`, ni form contenedor → no actúa.
 * - Vanilla JS puro (no requiere jQuery; el vendor sigue gestionando el resto).
 *
 * FASE C: este asset se cablea desde `layout/theme.liquid`
 * (p.ej. `{{ 'pj-localization-disclosure.js' | asset_url | script_tag }}`),
 * junto con el resto de módulos `pj-*.js`. Inerte hasta entonces.
 */
(function () {
  'use strict';

  // Marca anti-doble-registro (idempotencia a nivel de módulo).
  if (window.__pjLocalizationDisclosureInit) return;
  window.__pjLocalizationDisclosureInit = true;

  // Selector de la opción combinada país/idioma de PJ.
  // Solo las opciones de PJ llevan `data-tipo`; las del disclosure vendor no.
  var OPTION_SELECTOR = 'a[data-tipo][data-disclosure-option]';

  /**
   * Poda el input que NO corresponde al tipo de la opción clicada.
   * @param {Element} option - El <a data-tipo> sobre el que se hizo click.
   */
  function pruneInput(option) {
    if (!option) return;

    var tipo = option.getAttribute('data-tipo');
    if (!tipo) return;

    // Subir al <form> que contiene este disclosure (el form 'localization').
    var form = option.closest('form');
    if (!form) return;

    // Confirmar que es el form combinado: debe tener AMBOS inputs.
    // Si solo trae uno, es un disclosure vendor estándar → no tocar.
    var countryInput = form.querySelector('input[name="country_code"]');
    var localeInput = form.querySelector('input[name="locale_code"]');
    if (!countryInput || !localeInput) return;

    // Iso-funcional con 6.0.0:
    //   tipo == 'lengua' → enviar idioma → quitar country_code
    //   en otro caso     → enviar país   → quitar locale_code
    if (tipo === 'lengua') {
      countryInput.parentNode && countryInput.parentNode.removeChild(countryInput);
    } else {
      localeInput.parentNode && localeInput.parentNode.removeChild(localeInput);
    }
  }

  // Delegación en captura: corre ANTES del submit del disclosure vendor (burbuja).
  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || typeof target.closest !== 'function') return;

      var option = target.closest(OPTION_SELECTOR);
      if (!option) return;

      pruneInput(option);
    },
    true // useCapture
  );
})();
